export interface IData {
  title: string;
  text: string;
  withLabel?: boolean;
}

export const DATA: IData[] = [
  {
    title: 'Оценка объектов недвижимости',
    text: 'Высокая точность – 9 из 10 оценок стоимости квартиры совпадают с ценой сделки',
  },
  {
    title: 'Предсказание срока экспозиции',
    text:
      'Важно не только правильно предсказать стоимость недвижимости, но и знать в какие сроки квартира может быть продана',
    withLabel: true,
  },
  {
    title: 'Динамическое ценообразование',
    text:
      'Отслеживание рыночных тенденций и конкурентного окружения; максимизация прибыли на ликвидных квартирах; оперативное управление ценообразованием',
    withLabel: true,
  },
];
